import React from 'react';

const Input = ({
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo ${className ? className : ''}`}>
      <div className="subtitulo-p">
        <label htmlFor="numero">{label}</label>
      </div>
      <div className="controle">
        <input
          type={rest.type || 'text'}
          name={name}
          ref={inputRef}
          className={msgErro ? 'invalid' : ''}
          {...rest}
        />
      </div>
      <div className="mensagem">{msgErro}</div>
    </div>
  );
};

export default Input;

